import React, { useEffect, useState } from "react";
import { ResponsiveRadar } from "@nivo/radar";
import { auditService } from "@/stores/services/auditService";
import { useSearchParams } from "react-router-dom";
import { decryptId } from "@/utils/utilsMethods";
import { skipToken } from "@reduxjs/toolkit/query";

interface ReportAuditProps {
  companyId: number;
}
export default function ReportAudit({ companyId }: ReportAuditProps) {
  const [data, setData] = useState<Record<string, unknown>[]>([]);
  const [searchParams] = useSearchParams();
  const auditParam = searchParams.get("audit");
  const auditId = auditParam
    ? parseInt(decryptId(auditParam))
    : undefined;

  const { data: fetchRadar } = auditService.useRadarChartQuery(
    auditId && auditId > 0 ? { companyId, auditId } : skipToken,
  );

  const typesCycle = {
    P: "PLANEAR",
    H: "HACER",
    V: "VERIFICAR",
    A: "ACTUAR",
  };

  useEffect(() => {    
    if (Array.isArray(fetchRadar)) {
      const transformedData = fetchRadar.map((radar) => ({
        cycle: typesCycle[radar.cycle.toUpperCase() as keyof typeof typesCycle],
        porcentage: radar.cycle_percentage,
      })) as Record<string, unknown>[];
      setData(transformedData);         
    }
  }, [companyId, fetchRadar]);
  return (
    <>
      <div className="flex h-[27rem] w-full">
        <ResponsiveRadar
          data={data}
          keys={["porcentage"]}
          indexBy="cycle"
          maxValue="auto"
          margin={{ top: 70, right: 80, bottom: 40, left: 80 }}
          curve="linearClosed"
          borderWidth={2}
          borderColor={{ from: "color" }}
          gridLabelOffset={36}
          dotSize={10}
          dotColor={{ theme: "background" }}
          dotBorderWidth={2}
          dotBorderColor={{ from: "color" }}
          colors={"#0066B2"}
          fillOpacity={0.25}
          blendMode="multiply"
          animate={true}
          motionConfig="wobbly"
        />
      </div>
    </>
  );
}
